import { useState, useEffect } from "react";
import Modal from '../controls/Modal';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Cap, TableCap } from "../types/caps";
import CapsForm from "./modals/caps/Modal";
import CapsHistory from "./modals/caps/History";
import UnderwritingTemplate from "./templates/UnderwritingTemplate";
import { useCaps } from "../hooks/useCaps";
import UnderwritingTable from "./organisms/DataTable/UnderwritingTable";
import { MUIDataTableColumn } from "mui-datatables";
import * as format from "../utils/formatting"
import Tabs from '../components/molecules/Tabs';
import { Stack } from '@mui/material';

export const capsColumns: MUIDataTableColumn[] = [
    {
        name: "capID",
        options: {
            display: "false",
            filter: false,
        },
    },
    {
        name: "name",
        label: "Cap Name",
        options: {
            hint: "Cap Name",
        },
    },
    {
        name: "activePeriod",
        label: "Active",
        options: {
            hint: "Active Date",
            customBodyRender: format.dateRangeFormat
        },
    },

    {
        name: "amount",
        label: "Max Principal",
        options: {
            filter: false,
            hint: "Max Principal",
            customBodyRender: format.dollarsFormat
        },
    },
    {
        name: "period",
        label: "Time Frame",
        options: {
            filter: false,
            hint: "Time Frame",
        },
    },
    {
        name: "states",
        label: "Location",
        options: {
            hint: "Location",
            filterType: "multiselect",
            customBodyRender: format.arrayFormat,
        },
    },
    {
        name: "origins",
        label: "Origin",
        options: {
            filterType: "multiselect",
            customBodyRender: format.truncatedArrayFormat,
            hint: "Origin",
        },
    },
    /*Campaigns are no longer in use */
    // {
    //     name: "campaigns",
    //     label: "Campaign",
    //     options: {
    //         filterType: "multiselect",
    //         customBodyRender: format.truncatedArrayFormat,
    //         hint: "Campaign",
    //     },
    // },
];









const CapsView = () => {
    const [isCapsDialogOpen, setCapsDialogOpen] = useState(false);
    const [capsState] = useCaps();
    const [editCap, setEditCap] = useState<Cap | null>(null);
    const [data, setData] = useState<TableCap[]>([]);
    const [active, setActive] = useState<string>('detail');


    useEffect(() => {
        if (!capsState.fetching && capsState.receivedAt && capsState.data !== null) {

            const allCapsData = [
                ...capsState.data.map<TableCap>(x => ({
                    capID: x.capId,
                    name: x.name,
                    activePeriod: [x.activeStart, x.activeEnd],
                    amount: x.amount,
                    period: x.period,
                    states: x.states,
                    origins: x.origins.map(x => x.toString()),
                    campaigns: x.campaigns.map(x => x.toString()),
                    customerTypes: x.customerTypes ?? []
                }))
            ];
            setData(allCapsData);

            ;
        }
    }, [capsState]);
    const handleToggle = () => {
        setEditCap(null);

        isCapsDialogOpen ? setCapsDialogOpen(false) : setCapsDialogOpen(true);
    }

    const handleEditCap = (capID: number) => {
        const selected = capsState.byID[capID] ?? null;
        setCapsDialogOpen(true);
        setEditCap(selected);

    }
    return (
        <UnderwritingTemplate tableArea={<UnderwritingTable data={data} columns={capsColumns} title={"Caps Table"} onRowClick={handleEditCap} options={{ filterType: "textField" }} />}
            modalActions={
                <>
                    <Modal open={isCapsDialogOpen} onClose={handleToggle} title={`${editCap ? `Edit Cap ID ${editCap.capId}` : "Create Cap"}`} >
                        <Stack spacing={1} alignItems="center">
                            <Tabs active={active} onChange={setActive} buttonList={['detail', 'history']} />
                            {active === 'detail' && <CapsForm closeModal={handleToggle} cap={editCap || undefined} />}
                            {active === 'history' && editCap && <CapsHistory closeModal={handleToggle} cap={editCap} />}
                        </Stack>
                    </Modal>
                    <div style={{ position: 'fixed', bottom: 24, right: 24 }}>
                        <Fab onClick={() => setCapsDialogOpen(true)} color="secondary" aria-label="add-cap">
                            <AddIcon />
                        </Fab>
                    </div>
                </>
            }
        />




    )
}
export default CapsView

